module.exports = __webpack_public_path__ + "1792395595471/fonts/fa-solid-900.2d0415f.woff";